import { render } from "./RodoInformation.vue?vue&type=template&id=71922db4&ts=true"
import script from "./RodoInformation.vue?vue&type=script&lang=ts"
export * from "./RodoInformation.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__